import SportCodes from "../sports/common/sport-codes";
import FootballImporter from "./importers/football-importer";
import TennisImporter from "./importers/tennis-importer";
import {
    eventRepository,
    seasonRepository,
    teamRepository
} from "../storage/storage";

class ImportService {
    constructor() {
        this.importFactory = {
            [SportCodes.Football]: FootballImporter,
            [SportCodes.FlagFootball]: FootballImporter,
            [SportCodes.Tennis]: TennisImporter,
            [SportCodes.WomenTennis]: TennisImporter
        };
    }

    async importPlayers(teamId, importResult) {
        const team = await teamRepository.getById(teamId);
        const { seasonId } = team;
        const { sport } = await seasonRepository.getBySeasonId(seasonId);

        return this.importFactory[sport.sportId].importPlayers(
            teamId,
            importResult
        );
    }

    async validatePlayer(teamId, players, player) {
        const team = await teamRepository.getById(teamId);
        const { seasonId } = team;
        const { sport } = await seasonRepository.getBySeasonId(seasonId);

        return this.importFactory[sport.sportId].validateRecord(
            players,
            player
        );
    }

    async savePlayers(teamId, players) {
        const team = await teamRepository.getById(teamId);
        const { seasonId } = team;
        const { sport } = await seasonRepository.getBySeasonId(seasonId);

        return this.importFactory[sport.sportId].savePlayers(teamId, players);
    }

    async generateHeaders(eventId) {
        const event = await eventRepository.getById(eventId);
        const { sportId } = event;

        return this.importFactory[sportId].generateHeaders();
    }

    /**
     * @param {Record<string, string>[]} data
     * @returns {string}
     */
    convertToCsvString(data = []) {
        const csvRows = [];

        if (data?.length) {
            const headers = Object.keys(data[0]);

            csvRows.push(headers.join(","));
            for (const row of data) {
                const values = headers.map((header) => row[header]);
                csvRows.push(values.join(","));
            }
        }

        return csvRows.join("\n");
    }

    async validatePlayers(teamId, players) {
        const team = await teamRepository.getById(teamId);
        const { seasonId } = team;
        const { sport } = await seasonRepository.getBySeasonId(seasonId);

        return this.importFactory[sport.sportId].validateRecords(players);
    }

    async setGameData(gameId, teamId, players) {
        const team = await teamRepository.getById(teamId);
        const { seasonId } = team;
        const { sport } = await seasonRepository.getBySeasonId(seasonId);
        return this.importFactory[sport.sportId].setGameData(
            gameId,
            teamId,
            players
        );
    }
}

export default new ImportService();
